/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import DialerServiceData from "Stores/DialerServiceStore";
import { toasterState } from "Components/common/toaster";
import Utils from "Utils/utils";
import { voBizBuyNumberPopupState } from "Pages/Dashboard/settings/VoBizBuyNumberPopup";
import countryData from "country-telephone-data";
import Flags from "Assets/png/flags.png";
import PhoneNumberDropdown from "./PhoneNumberDropdown";
import userDetail from "Stores/userDetail";
import {
  getPreferredCallerId,
  setPreferredCallerId
} from "Utils/dialerPreferences";
import "react-telephone-input/css/default.css";

const getCountryFromPhoneNumber = phoneNumber => {
  if (!phoneNumber) return null;

  const { allCountries, allCountryCodes, iso2Lookup } = countryData;
  const cleanNumber = phoneNumber.replace(/[^\d+]/g, "");
  const inputNumberForCountries = cleanNumber.replace(/^\+/, "").substr(0, 4);

  if (allCountryCodes[inputNumberForCountries]) {
    const iso2 = allCountryCodes[inputNumberForCountries][0];
    if (iso2 && iso2Lookup[iso2] !== undefined) {
      const country = allCountries[iso2Lookup[iso2]];
      if (country) return country;
    }
  }

  let bestMatch = { dialCode: "", priority: 10001 };

  allCountries.forEach(country => {
    const numberToCheck = cleanNumber.startsWith("+")
      ? cleanNumber.replace(/^\+/, "")
      : cleanNumber;
    const dialCodeToCheck = country.dialCode.replace(/^\+/, "");

    if (numberToCheck.startsWith(dialCodeToCheck)) {
      if (
        dialCodeToCheck.length > bestMatch.dialCode.replace(/^\+/, "").length
      ) {
        bestMatch = country;
      } else if (
        dialCodeToCheck.length ===
          bestMatch.dialCode.replace(/^\+/, "").length &&
        country.priority < bestMatch.priority
      ) {
        bestMatch = country;
      }
    }
  });

  if (!bestMatch || !bestMatch.name || bestMatch.priority === 10001) {
    return null;
  }

  return bestMatch;
};

const CountryFlag = ({ country }) => {
  if (!country || !country.iso2) return null;

  return (
    <div className="react-tel-input">
      <div
        className={`flag ${country.iso2.toLowerCase()}`}
        style={{ backgroundImage: `url(${Flags})` }}
      ></div>
    </div>
  );
};

const DialerDefaultNumber = props => {
  const { calling = false, isVoBiz = false } = props;
  const [loader, setLoader] = useState(true);
  const [phoneNoList, setPhoneNoList] = useState([]);
  const [defaultNo, setDefaultNo] = useState("");
  const [showDropdownMenu, setDropdownMenu] = useState(false);

  // Which store fields to read from depends on channel
  const storeDefaultNo = isVoBiz ? DialerServiceData.voBizDefaultNo : DialerServiceData.dialerDefaultNo;
  const storePhoneList = isVoBiz ? DialerServiceData.voBizPhoneList : DialerServiceData.dialerPhoneList;

  const showDropdownPhoneList = () => {
    setDropdownMenu(true);
  };

  const hideDefaultNoList = () => {
    setDropdownMenu(false);
  };

  const channelKey = isVoBiz ? "india" : "default";

  const updateDefaultNo = (item) => {
    toasterState.setToastMsg("Please wait...", "info");
    setPreferredCallerId(userDetail.memberId, channelKey, item.value);
    if (isVoBiz) {
      DialerServiceData.updateVoBizDefaultPhoneNumber({ ph_number: item.value });
    } else {
      DialerServiceData.dialerBtnLoader = true;
      DialerServiceData.updateDefaultPhoneNumber({ ph_number: item.value });
      setLoader(true);
    }
    setDropdownMenu(false);
  };

  const getDialerDefaultNo = () => {
    if (storeDefaultNo) {
      // The server is the authority: for India the number VoBiz actually dials with
      // comes from member_vobiz.fromNumber, so showing a locally remembered number
      // that disagrees would display one caller ID while dialing another.
      setDefaultNo(storeDefaultNo);
      setLoader(false);
    } else {
      // Still loading — paint the last used number instead of an empty box, so the
      // dialer opens looking ready. Replaced by the server value the moment it lands.
      const remembered = getPreferredCallerId(userDetail.memberId, channelKey);
      if (remembered) {
        setDefaultNo(remembered);
      }
    }
  };

  const constructDropdownList = phoneList => {
    const newPhoneList = [];
    phoneList?.length &&
      phoneList.map((item, index) => {
        // item can be a string (US numbers) or an object {number, configured} (VoBiz numbers)
        const numStr = typeof item === "string" ? item : item?.number;
        if (!numStr) return;
        let newObj = {
          value: numStr,
          key: `phoneNumber${index + 1}`,
          country: getCountryFromPhoneNumber(numStr)
        };
        newPhoneList.push(newObj);
      });
    setPhoneNoList(newPhoneList);
  };

  const purchaseNumberRedirect = () => {
    if (Utils.isAdmin()) {
      voBizBuyNumberPopupState.setShowPopup(true);
    } else {
      toasterState.setToastMsg(
        "No India calling number purchased. Please contact your account administrator.",
        "fail"
      );
    }
  };

  useEffect(() => {
    if (storePhoneList && storePhoneList.length > 0) {
      constructDropdownList(storePhoneList);
    }
  }, [storePhoneList]);

  useEffect(() => {
    if (!isVoBiz) {
      setLoader(DialerServiceData.dialerBtnLoader);
    }
  }, [DialerServiceData.dialerBtnLoader]);

  useEffect(() => {
    getDialerDefaultNo();
  }, [storeDefaultNo]);

  const countryInfo = getCountryFromPhoneNumber(defaultNo);

  return (
    <div className="dsDefaultNoSection">
      <div className="dsWrapDefautContact">
        {!loader && (
          <>
            {defaultNo && defaultNo !== "purchaseNumber" && (
              <div
                onClick={() => {
                  !calling && showDropdownPhoneList();
                }}
                className="numberSection"
              >
                <div className="text">Calling from: </div>
                <div className="number">
                  {countryInfo && <CountryFlag country={countryInfo} />}
                  <span className="numberText">{defaultNo}</span>
                  {!calling && (
                    <i className="material-icons">keyboard_arrow_up</i>
                  )}
                </div>
              </div>
            )}
            {defaultNo === "purchaseNumber" && (
              <>
                <div className="text">Calling from: </div>
                <div onClick={purchaseNumberRedirect} className="purchaseNumber">
                  Purchase Number
                </div>
              </>
            )}
          </>
        )}
        {loader && (
          <>
            <div className="text">Calling from: </div>
            <span className="defaultNoLoader linear-background"></span>
          </>
        )}
        {showDropdownMenu && (
          <PhoneNumberDropdown
            phoneNumbers={phoneNoList}
            selectedNumber={defaultNo}
            onSelect={updateDefaultNo}
            onClose={hideDefaultNoList}
          />
        )}
      </div>
    </div>
  );
};
export default withRouter(observer(DialerDefaultNumber));
export { DialerDefaultNumber };

